export class UnsupportedWalletAccountSource extends Error {
    constructor(source) {
        super(`unable to sign for this wallet account source: ${source}`);
    }
}
